import * as Store from "./authenticated.store";
import * as Effects from "./authenticated.effects";
import * as Selectors from "./authenticated.selectors";
import * as Actions from "./authenticated.actions";
const publicActions = {
    fetchAuthenticated: Actions.fetchAuthenticated,
};
export const Authenticated = {
    Store: Store.AuthenticatedStore,
    Effects: Effects.default,
    Selectors,
    Actions: publicActions,
};
